import React from 'react'
import '../Home/Home.css'
import Navbar from '../Navbar/Navbar'
import PosterSection from '../Poster/Poster'
import VisionMissionSection from '../Mission/Mission'
import WhyChooseUs from '../Why/Why'
import InstrumentsGrid from '../Grids/Grids'
import About from '../About/About'
import Footer2 from '../Footer2/Footer2'
import CompanySection from '../Company/Company'
import Connect from '../Connect/Connect'

const Home = () => {
  return (
    <>
      
        <PosterSection/>
        <CompanySection/>
        <About/>
        <InstrumentsGrid/>
        <VisionMissionSection/>
        <WhyChooseUs/>
        <div className='coc'>
        <Connect/>
        </div>
       
      
    </>
  )
}

export default Home